import { Injectable } from '@angular/core';
import {   Response, Headers, ResponseContentType } from '@angular/http';

import "rxjs/add/operator/map"
import { Observable } from 'rxjs/Observable';
import { Modelcores } from '../entity/Pjoint';
import { AppSettings } from './app.setting';
import { environment } from 'src/environments/environment';
import { Socifact } from '../entity/Facture';
import { HttpClient } from '@angular/common/http';
 


@Injectable()
export class AdminService {
  private baseUrl = environment.restApi;
  private modelcoresUrl = `${this.baseUrl}modelcores`;
  private socifactUrl = `${this.baseUrl}socifact`;
 
  constructor( private http : HttpClient) { }
  
  findAllModelsCoresp(): Observable <Modelcores[]> {
    let Modelcores$ = this.http.get<Modelcores[]>(`${this.modelcoresUrl} ` );
    return Modelcores$;
  } 
  findAllSocifact(): Observable <Socifact[]> {
    let socifact$ = this.http.get<Socifact[]>(`${this.socifactUrl} ` ) ;
    return socifact$;
  } 

  createModelsCoresp(modelcores: Modelcores): Observable<Response> {
 
    return this.http.post<any>(`${this.modelcoresUrl}/`, modelcores  );
  }
  createSocifact(socifact: Socifact): Observable<Response> {
 
    return this.http.post<Response>(`${this.socifactUrl}/`, JSON.stringify(socifact) );
  }



  saveModelsCoresp(modelcores: Modelcores): Observable<Modelcores> {
    return this.http.put<Modelcores>(`${this.modelcoresUrl}/` + modelcores.modelcoresId, modelcores  );
  }

  saveSocifact(socifact: Socifact): Observable<Socifact> {
    return this.http.put<Socifact>(`${this.socifactUrl}/` + socifact.sociFactId,  socifact );
  }




  removeModelsCoresp(modelcores: Modelcores): Observable<Modelcores> {
    return this.http.delete<Modelcores>(`${this.modelcoresUrl}/` + modelcores.modelcoresId)
  }

  removeSocifact(socifact: Socifact): Observable<Socifact> {
    return this.http.delete<Socifact>(`${this.socifactUrl}/` + socifact.sociFactId)
  }

  uploadFile(file: FormData,fileName:string,socifact:number): Observable<Response> {
 

    return this.http.post<any>(`${this.socifactUrl}/upload/${socifact}/${fileName}`, file);
  }

   showFile(socifact: Socifact): any {

    let pjoint$ =  this.http.get(`${this.socifactUrl}/showFile/${socifact.sociFactId}/tete` , { responseType: "blob"})  ;
    return pjoint$;
  }

  private getHeaders1() {
    let headers = new Headers();
    headers.append('Accept', 'image/png');

    headers.append("Content-Type", "image/png");

    return headers;
  }



  private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return headers;
  }

}

function mapModelcore(response: Response): Modelcores {
  return toModelcores(response.json());
}

function mapModelcores(response: Response): Modelcores[] {
  return response.json().map(toModelcores);
}
function toModelcores(r: any): Modelcores {
  return r;
}